import { createIcon } from '@chakra-ui/react';

export const OneXbetLogo = createIcon({
  displayName: 'OneXbetLogo',
  viewBox: '0 0 55 30',
  path: (
    <>
      <path
        d='M9.54186 30H0.34619L4.32738 13.9785L5.24694 11.5591L2.81279 13.9785L0.108184 16.6989L0 8.69893L9.54186 0H16.9741L9.54186 30Z'
        fill='currentColor'
      />
      <path
        d='M42.7437 17.5699L39.8119 12.6344L54.0381 0H40.7855L35.3763 5.16129L17.0283 21.8817L8.22205 30H20.7606L30.1835 21.6452L33.3533 27.0215C34.4351 28.3763 35.9605 30.0215 42.43 30.0215H50.0029L42.7545 17.5591L42.7437 17.5699Z'
        fill='currentColor'
      />
      <path
        d='M34.3594 3.50537V3.44086C33.5477 2.31534 32.4646 1.41046 31.2095 0.809265C29.9543 0.208066 28.5674 -0.0702018 27.1759 -2.92156e-06H17.3853L24.6877 12.3441L34.3594 3.50537Z'
        fill='currentColor'
      />
    </>
  ),
});
